import type { components } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type UsersParams = {
  community_ids: string[];
  cursor?: string;
  limit?: number;
  // TODO this should be type
  role?: 'admin' | 'member';
  scope: 'communities';
  search?: string;
};

export const getCommunityUsersAutocomplete = async ({ config }: ConfigRequest<UsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.community.autoComplete,
    config,
  );
